import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../api";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";

export const SET_LOADING = "saga/regions/SET_LOADING";

export const FETCH_REGIONS_SUCCESS = "saga/regions/FETCH_REGIONS_SUCCESS";

export const ADD_REGION = "saga/regions/ADD_REGION";
export const ADD_REGION_SUCCESS = "saga/regions/ADD_REGION_SUCCESS";

export const EDIT_REGION = "saga/regions/EDIT_REGION";
export const EDIT_REGION_SUCCESS = "saga/regions/EDIT_REGION_SUCCESS";

export const DELETE_REGION = "saga/regions/DELETE_REGION";
export const DELETE_REGION_SUCCESS = "saga/regions/DELETE_REGION_SUCCESS";

export const FETCH_CURRENT_USER = "saga/regions/FETCH_CURRENT_USER";

export const RESET_FILTERS = "saga/regions/RESET_FILTERS";
export const SET_ERROR = "saga/regions/SET_ERROR";
export const SET_STATUS = "saga/regions/SET_STATUS";
export const SET_DEFAULT_REGION = "saga/regions/SET_DEFAULT_REGION";
export const SET_DEFAULT_REGION_SUCCESS = "saga/regions/SET_DEFAULT_REGION_SUCCESS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  makeDefault: createAction(SET_DEFAULT_REGION),
  createRegion: createAction(ADD_REGION),
  changeRegion: createAction(EDIT_REGION),
  deleteRegion: createAction(DELETE_REGION),
  resetFilters: createAction(RESET_FILTERS)
};

export const {
  fetchCurrentUser,
  createRegion,
  changeRegion,
  deleteRegion,
  resetFilters,
  makeDefault
} = actionCreators;

export default function* watchRegions() {
  yield takeLatestSafe(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatestSafe(ADD_REGION, addRegion);
  yield takeLatestSafe(EDIT_REGION, editRegion);
  yield takeLatestSafe(DELETE_REGION, removeRegion);
  yield takeLatestSafe(SET_DEFAULT_REGION, setAsDefault);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getCurrentUserData() {
  yield put({ type: SET_LOADING, payload: true });

  yield fetchRegions();

  yield put({ type: SET_LOADING, payload: false });
}

function* fetchRegions() {
  const { organization_id } = getBaseUrlParams();

  const { data } = yield call(api.getRegions, { params: { organization_id } });

  yield put({
    type: FETCH_REGIONS_SUCCESS,
    payload: data
  });
}

function* setAsDefault(data) {
  const { organization_id } = getBaseUrlParams();

  yield call(api.setAsDefault, { organization_id, id: data.payload.toString() });

  yield put({
    type: SET_DEFAULT_REGION_SUCCESS,
    payload: data.payload
  });
}

function* addRegion(data) {
  yield put({ type: SET_STATUS, payload: "pending" });

  const { organization_id } = yield getBaseUrlParams();

  const { name, locations } = data.payload;

  const ids =
    locations.length > 0 ? { location_ids: locations.map((location) => location.id) } : {};

  const res = yield call(api.addRegion, {
    organization_id,
    region: {
      name,
      ...ids
    }
  });

  yield put({
    type: ADD_REGION_SUCCESS,
    payload: res.data
  });

  yield put({ type: SET_STATUS, payload: "idle" });
}

function* editRegion(data) {
  yield put({ type: SET_STATUS, payload: "pending" });

  const { organization_id } = yield getBaseUrlParams();

  let { id, locations, name } = data.payload;
  const location_ids = locations.map((location) => location.id);

  yield call(api.updateRegion, id, {
    organization_id,
    region: {
      name,
      ...(location_ids.length > 0 ? { location_ids } : [])
    }
  });

  yield put({
    type: EDIT_REGION_SUCCESS,
    payload: { id, name, location_ids }
  });

  yield put({
    type: RESET_FILTERS
  });
}

function* removeRegion(data) {
  const { organization_id } = yield getBaseUrlParams();
  yield call(api.removeRegion, { params: { organization_id, id: data.payload } });

  yield put({
    type: DELETE_REGION_SUCCESS,
    payload: { id: data.payload }
  });

  yield put({
    type: RESET_FILTERS
  });
}
